import React, {
  useState,
  useRef,
  useEffect,
  ChangeEvent,
  MouseEventHandler,
} from "react";
import { updateIsFavorite } from "../services/firebase";
import { useAuth } from "../contexts/AuthContext";
import { Trash2, X } from "lucide-react";
interface FavouritePunishmentProps {
  id: string;
  isFavourite: boolean;
  collectionName?: string;
  onError?: (error: string | undefined) => void;
  onSuccess?: (message: string) => void;
}

const FavouritePunishment: React.FC<FavouritePunishmentProps> = ({
  id,
  isFavourite = false,
  onError,
  onSuccess,
  collectionName,
}) => {
  const { userRole } = useAuth();
  const isAdmin = userRole === "admin";
  const [checked, setChecked] = useState<boolean>(isFavourite);

  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    // Prevent this click from bubbling up to the parent div
    e.stopPropagation();
    const newChecked = !isFavourite;
    updateIsFavorite(collectionName ? "draftIdeas" : "content", id, newChecked)
      .then((docId: string) => {
        if (docId) {
          setChecked(newChecked);
          onSuccess && onSuccess("Added to favorites");
        } else {
          setChecked(isFavourite);
          console.log("Error updating favorite status");
          onError &&
            onError(
              "Unable to update favorite status. You may have exceeded the limit of 4 favorite items. Please remove one before adding another."
            );
        }
      })
      .catch((e) => {
        console.log(e);
        setChecked(isFavourite);
        onError &&
          onError("Unable to update favorite status. Please try again later.");
      });
  };

  if (!isAdmin) return null;
  return (
    <span
      className={checked === true ? "favoriteIcon active" : "favoriteIcon"}
      onClick={handleClick}
    >
      Favorite
    </span>
  );
};

export default FavouritePunishment;
